import { arrToObject } from 'utils/functional';

type Level = Readonly<{
  id: string;
  name: string;
}>;

export const levelOptions = (levels: ReadonlyArray<Level>): Array<string> =>
  levels.map((level) => level.id);

export const levelOptionTitles = (
  levels: ReadonlyArray<Level>
): Record<string, string> => arrToObject(levels.map((l) => [l.id, l.name]));

export const hasLocation = (s: SearchLocation | null | undefined): boolean =>
  // @ts-expect-error TS(2322): Type 'boolean | null | undefined' is not assignabl... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  s && s.hasGeo;

export const isLocationEmpty = (s: SearchLocation | null | undefined) => {
  if (!s) return true;

  const { hasGeo, ...rest } = s;

  return Object.values(rest).every((o) => o === null) && !hasGeo;
};
